<template>
  <div ref="lesson" :class="$style.wrapper" class="allow-scroll">
    <MobileLandscapeDummy/>
    <Header :currentTask="currentTask" :points="score"/>
    <Points :numberOfPoints="score" :position="pointsPosition" :class="$style.points"/>
    <div :class="[$style.innerWrapper, { [$style.mobileBgGrid]: currentTask===1 }]">
      <transition name="fade" v-for="(popup, index) in popupList" :key="popup.title">
        <LevelPopup
          v-if="currentPopupId===index"
          ref="popup"
          :icon="popup.icon"
          :title="popup.title"
          :description="popup.description"
          :showPoints="index===3"
          :showCertificate="false"
          :numberOfPoints="score"
          :hideButton="false"
          :showCertificateLink="index===3"
          :btnText="index===2 ? 'Продолжить' : null"
          @close="closePopupHandler(index)"
          @getCertificate="getCertificate"
          @share="() => $vk.shareDefault({ image: 'photo-174311295_457241385' })"
        >
          <div class="videoPopup__inner" v-if="index === 2" style="position: relative; padding-bottom: 56.25%; height: 0;"><iframe src="https://www.loom.com/embed/fc2c9317dead4812804ccc66af2c9dfc" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe></div>
        </LevelPopup>
      </transition>
      <div :class="[$style.constructor, $style.analyticsBlock, currentTask!==1 && 'hidden']" class="constructor">
        <div :class="$style.constructorTitle">
          <img src="@/assets/lesson4/task2/conus.svg" :class="$style.img" alt="analytics">
          <span>Панель конструктор</span>
        </div>
        <div class="block" :class="$style.constructorElements" data-type="constructor">
          <div :class="$style.blockType">
            <p :class="$style.constructorElementTitle">Навигация</p>
            <div ref="constructorTop" :class="$style.constructorElementWrapper" class="dropzone draggable-dropzone--occupied" data-container="constructor">
              <div ref="item" class="item pointer" :class="$style.element" v-for="item in elements.filter(item => item.type === 'navigation')" :key="item.field" :data-type="item.field" :data-zone="item.type">
                <div :class="$style.elementIcon" :style="{ backgroundColor: `${item.bgColor}` }">
                  <div :class="$style.elementImage" :style="{ backgroundImage: `url(${require(`@/assets/lesson4/task2/${item.field}_2.svg`)})`}"></div>
                  <div :class="$style.elementTitle">
                    <span>{{item.title}}</span>
                  </div>
                </div>
                <div :class="$style.elementHtml">
                  <img :src="require(`@/assets/lesson4/task2/elements/${item.field}.png`)" :class="$style.img" alt="next">
                </div>
              </div>
            </div>
          </div>
          <div :class="$style.blockType">
            <p :class="$style.constructorElementTitle">Основной экран</p>
            <div ref="constructorBottom" :class="$style.constructorElementWrapper" class="dropzone draggable-dropzone--occupied" data-container="constructor">
              <div ref="item" class="item pointer" :class="$style.element" v-for="item in elements.filter(item => item.type === 'main')" :key="item.field" :data-type="item.field" :data-zone="item.type">
                <div :class="$style.elementIcon" :style="{ backgroundColor: `${item.bgColor}` }">
                  <div :class="$style.elementImage" :style="{ backgroundImage: `url(${require(`@/assets/lesson4/task2/${item.field}_2.svg`)})`}"></div>
                  <div :class="$style.elementTitle">
                    <span>{{item.title}}</span>
                  </div>
                </div>
                <div :class="$style.elementHtml">
                  <img :src="require(`@/assets/lesson4/task2/elements/${item.field}.png`)" :class="$style.img" alt="next">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="currentTask>1" :class="[$style.codeEditor, currentTask!==2 && 'hidden']">
        <div :class="$style.blockHeader">
          <img src="@/assets/lesson4/task3/editor.svg" :class="$style.img" alt="editor">
          <span>Code Editor</span>
        </div>
        <div :class="$style.editor">
          <div :class="$style.importZone">
            <span>import 'dart:async';<br/>import 'package:webview_flutter /<br/>webview_flutter.dart';</span>
          </div>
          <div :class="$style.codeZone">
            <label ref='function_zoneTop' for='function_1'>void main() => runApp(MyApp());<br/><br/>class MyApp extends Widget {<br/>class TopBar {<br/>
              <span class="point"></span>
              <autocomplete ref="zoneTopFunction" id='function_1' class="code" :suggestions="suggestions" :close="highlight !== 'zoneTop'" placeholder="// добавь сюда код нужной функции" v-model="selectedFunctions.zoneTop" @focus="highlight = 'zoneTop'"></autocomplete>
              }<br/>
            </label>
            <label ref='function_zoneCenter' for='function_2'>class Main {<br/>
              <span class="point"></span>
              <autocomplete ref="zoneCenterFunction" id='function_2' class="code" :suggestions="suggestions" :close="highlight !== 'zoneCenter'" placeholder="// добавь сюда код нужной функции" v-model="selectedFunctions.zoneCenter" @focus="highlight = 'zoneCenter'"></autocomplete>
              }<br/>
            </label>
            <label ref='function_zoneBottom' for='function_3'>class Nav {<br/>
              <span class="point"></span>
              <autocomplete ref="zoneBottomFunction" id='function_3' class="code" :suggestions="suggestions" :close="highlight !== 'zoneBottom'" placeholder="// добавь сюда код нужной функции" v-model="selectedFunctions.zoneBottom" @focus="highlight = 'zoneBottom'"></autocomplete>
              }<br/>}
            </label>
          </div>
        </div>
      </div>
      <div v-if="currentTask===2" :class="[$style.handbook, $style.analyticsBlock]">
        <div :class="[$style.blockHeader, $style.constructorTitle]">
          <img src="@/assets/lesson4/task3/function.svg" :class="$style.img" alt="function">
          <span>Справочник функций</span>
        </div>
        <div :class="$style.functionsWrapper">
          <div v-for="element in elements" :key="element.field" :class="[$style.function, selectedFunctionsCheck(element.function) && 'disable']">
            <button :class="$style.functionButton" @click="insertFunctionToCodeEditor(element.function)">
              <img src="@/assets/lesson4/task3/plusButton.svg" :class="$style.img" alt="next">
            </button>
            <span :class="$style.functionHelp">{{element.title}}</span>
            <span :class="$style.functionTitle">{{element.function}}</span>
          </div>
        </div>
      </div>
      <div v-if="currentTask===3" :class="[$style.checkList, $style.analyticsBlock]">
        <div :class="[$style.blockHeader, $style.checkListTitle]">
          <span>Чек-лист тестировщика</span>
        </div>
        <div :class="$style.checkListWrapper">
          <div :ref="`check${ item.field }`" :class="$style.checkListItem" v-for="item in selectedElementsInfo" :key="item.field">
            <test-check-box :class="$style.checkBox" :disabled="elementIsChecked[item.field]" v-model="elementIsChecked[item.field]" @change="testElement(item.field)"></test-check-box>
            <span :class="$style.title">Проверить работу элемента {{item.title.toLowerCase()}}</span>
          </div>
        </div>
      </div>
      <div :class="[$style.phone, $style.analyticsBlock, {[$style.phoneToTop]: currentTask===1}, (currentTask<1 || currentTask>3 ) && 'hidden']" class="phone">
        <div :class="[$style.phoneWrapper, {[$style.phonePadding]: currentTask===1}]">
          <div :class="$style.phoneHeader">
            <div :class="$style.time">{{ this.time }}</div>
            <img src="@/assets/lesson4/task2/notch.png" :class="$style.notch" alt="notch">
            <div :class="$style.icons">
              <img src="@/assets/lesson4/task2/rightSide.svg" :class="$style.img" alt="rightSide">
            </div>
          </div>
          <div :class="$style.phoneDropzones" class="block" data-type="phone">
            <div ref="zoneTop" :class="[$style.phoneDropzone, currentTask===1 && $style.roundBorder, currentTask===2 && highlight==='zoneTop' && 'highlight', testResult.zoneTop === false && 'highlightWrong', testResult.zoneTop === true &&'highlightRight']" class="dropzone" data-container="zoneTop" @click="setFocus('zoneTop')">
              <div v-if="currentTask > 1 && currentTask < 4" ref="item" class="item pointer" :class="$style.element">
                <div :class="$style.elementHtml">
                  <img :src="require(`@/assets/lesson4/task2/elements/${selectedElementsInfo.zoneTop.field}.png`)" :class="$style.img" alt="next">
                </div>
              </div>
              <div v-else class="item" :class="$style.defaultItem" data-type="unset"></div>
            </div>
            <div ref="zoneCenter" :class="[$style.phoneDropzone, currentTask===1 && $style.roundBorder, currentTask===2 && highlight==='zoneCenter' && 'highlight', testResult.zoneCenter === false && 'highlightWrong', testResult.zoneCenter === true &&'highlightRight']" class="dropzone" data-container="zoneCenter" @click="setFocus('zoneCenter')">
              <div v-if="currentTask > 1 && currentTask < 4" ref="item" class="item pointer" :class="$style.element">
                <div :class="$style.elementHtml">
                  <img :src="require(`@/assets/lesson4/task2/elements/${selectedElementsInfo.zoneCenter.field}.png`)" :class="$style.img" alt="next">
                </div>
              </div>
              <div v-else class="item" :class="$style.defaultItem" data-type="unset"></div>
            </div>
            <div ref="zoneBottom" :class="[$style.phoneDropzone, currentTask===1 && $style.roundBorder, currentTask===2 && highlight==='zoneBottom' && 'highlight', testResult.zoneBottom === false && 'highlightWrong', testResult.zoneBottom === true &&'highlightRight']" class="dropzone" data-container="zoneBottom" @click="setFocus('zoneBottom')">
              <div v-if="currentTask > 1 && currentTask < 4" ref="item" class="item pointer" :class="$style.element">
                <div :class="$style.elementHtml">
                  <img :src="require(`@/assets/lesson4/task2/elements/${selectedElementsInfo.zoneBottom.field}.png`)" :class="$style.img" alt="next">
                </div>
              </div>
              <div v-else class="item" :class="$style.defaultItem" data-type="unset"></div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="currentTask===0" :class="$style.diagrams">
        <div :class="$style.analyticsBlock">
          <div :class="$style.header">
            <span :class="$style.title">Пол</span>
            <div :class="$style.select">
              <v-select :options="[{label: 'Мужской', field: 1}, {label: 'Женский', field: 0}]"
                        :searchable="false"
                        :clearable="false"
                        v-model="genderSelected">
              </v-select>
            </div>
          </div>
          <div :class="$style.chartWrapper">
            <PieChart :class="$style.chart" :chartData="getChartData(genderStatistics, 0)"/>
          </div>
        </div>
        <div :class="$style.analyticsBlock">
          <div :class="$style.header">
            <span :class="$style.title">Город</span>
            <div :class="[$style.select, $style.region]">
              <v-select :options="this.regionShortList"
                        :searchable="false"
                        :clearable="false"
                        v-model="regionSelected">
              </v-select>
            </div>
          </div>
          <PieChart :class="$style.chart" :chartData="getChartData(regionStatistics, 0)" />
        </div>
        <div :class="$style.analyticsBlock">
          <div :class="$style.header">
            <span :class="$style.title">Возраст</span>
            <div :class="$style.select">
              <v-select :options="[{label: '14 лет', field: 14}, {label: '15 лет', field: 15}, {label: '16 лет', field: 16}, {label: 'Другое', field: 'other'}]"
                        :searchable="false"
                        :clearable="false"
                        v-model="ageSelected">
              </v-select>
            </div>
          </div>
          <div :class="$style.chartWrapper">
            <PieChart :class="$style.chart" :chartData="getChartData(ageStatistics, 1)"/>
          </div>
        </div>
      </div>
      <div v-if="currentTask===0" :class="[$style.interests, $style.analyticsBlock]">
        <span :class="$style.title">Интересы</span>
        <div :class="$style.interestsItem" v-for="(item, index) in interestsList" :key="index">
          <check-box :class="$style.checkBox" v-model="interestsIsChecked[item.field]" @change="updateInterestsSelected(item.field)"/>
          <div :class="$style.info">
            <div :class="$style.header">
              <span :class="$style.title">{{item.title}}</span>
              <span :class="$style.percent">{{item.count}}%</span>
            </div>
            <div :class="$style.progressBar">
              <NewProgressBar :progress="item.count"/>
            </div>
          </div>
        </div>
        <div :class="[$style.select, $style.interestsSelect]">
          <v-select :options="interestsListMobile"
                    :searchable="false"
                    :clearable="false"
                    label="title"
                    v-model="interesSelected">
          </v-select>
        </div>
      </div>
      <personage v-if="currentTask<2" :cityImage="cityImage" :characterImg="character.img" :description="character.description" :class="[{[$style.mobileHidden]: currentTask}]"/>
      <transition name="bounce">
        <publication-form v-if="currentTask===4 && showPublication"
                          :class="$style.analyticsBlock"
                          :interestsList="interestsList"
                          @closePublicationPopup="closePublicationPopup"
                          @showHelpBox="showHelpBox=true"/>
      </transition>
      <button v-if="currentTask<4" :disabled="!showNextButton" :class="$style.mobileNextButton" @click="showNextTask">
        <img src="@/assets/lesson4/arrow.svg" :class="$style.img" alt="next">
      </button>
    </div>
    <transition name="fade">
      <button v-if="showNextButton" :class="$style.nextButton" @click="showNextTask">
        <img src="@/assets/lesson4/arrow.svg" :class="$style.img" alt="next">
      </button>
    </transition>
    <helpBox
      ref="helpbox"
      :type="wrongTest ? 'warning' : helpBoxText[currentTask][helpBoxTextNumber].type"
      :description="wrongTest ? wrongTestMessage : helpBoxText[currentTask][helpBoxTextNumber].text"
      :show="showHelpBox"
      @open="showHelpBox=true"
      @close="closeHelpBox"
      @closeWarning="closeWarning"
    />
  </div>
</template>

<script>
import { Swappable } from '@shopify/draggable'
import api from '@/api'
import Points from '@/components/Points/Points'
import Header from './components/header/header'
import PieChart from './components/PieChart/PieChart'
import Personage from './components/personage/personage'
import NewProgressBar from '../../components/NewProgressBar/NewProgressBar'
import CheckBox from '@/components/CheckBox/checkBox'
import helpBox from './components/helpBox/helpBox'
import LevelPopup from '../../components/LevelPopup/LevelPopup'
import PublicationForm from './components/publicationForm/publicationForm'
import Autocomplete from './components/autocomplete/autocomplete'

import saveDataMixin from '@/mixins/saveData'
import MobileLandscapeDummy from '../../components/MobileLandscapeDummy/MobileLandscapeDummy'
import TestCheckBox from './components/testCheckBox/testCheckBox'

// max 100
export default {
  name: 'lesson4',
  components: {
    TestCheckBox, MobileLandscapeDummy, Autocomplete, PublicationForm, LevelPopup, helpBox, CheckBox, NewProgressBar, Header, Points, Personage, PieChart,
  },
  mixins: [saveDataMixin],
  metaInfo: {
    meta: [{
      name: 'viewport',
      content: 'width=device-width, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no',
    }],
  },
  data() {
    return {
      score: 0,
      pointsPosition: 'right',
      time: '',
      currentTask: 0,
      showHelpBox: false,
      helpBoxText: [
        [{ type: '', text: 'Всё начинается с идеи! Чтобы понять, будет ли популярным будущее приложение, нужно провести исследование и анализ аудитории. В IT-компаниях этим занимаются аналитики.\n' },
          { type: 'task', text: 'Проведи анализ целевой аудитории: выбери <b>город, возраст, пол.</b> Статистика покажет тебе, чем интересуется конкретная группа. Выбери самую популярную тематику — именно она станет темой твоего будущего приложения.\n' },
        ],
        [{ type: '', text: 'Далее разрабатывается прототип — макет будущего приложения, который даёт понять, как приложение должно работать. На основе прототипа создаётся финальный вид приложения: определяются цвета, отрисовываются элементы и другое. За это отвечают UX и UI дизайнеры.\n' },
          { type: 'task', text: 'Выбери необходимые функции для твоего будущего приложения, перетащи их на экран телефона. Нейросеть поможет создать карточку функции.' }],
        [{ type: '', text: 'Чтобы приложение «ожило», нужно разработать его техническую часть. В IT-компаниях этим занимаются программисты. Они пишут код приложения на основе прототипа, который разработал дизайнер.' },
          { type: 'task', text: 'Нейросеть уже сгенерировала код на основе разработанного дизайна. Осталось дописать код функций. Посмотри в справочнике, как выглядит код функций, используемых в твоём приложении и допиши их в редакторе кода.\n' }],
        [{ type: '', text: 'Когда приложение готово, его нужно протестировать. В IT-компаниях этим занимаются тестировщики. Они проверяют работоспособность каждой функции приложения.\n' },
          { type: 'task', text: 'Проверь работоспособность функций приложения. Если какая-то функция не работает, нейросеть поможет определить причину ошибки.\n' }],
        [{ type: '', text: 'Ты прошел все этапы разработки приложения. Чтобы его увидели другие пользователи, его нужно опубликовать в магазине приложений.\n' },
          { type: 'task', text: 'Заполни анкету, в которой расскажешь о своём приложении подробнее.\n' }],
      ],
      helpBoxTextNumber: 0,
      interestsIsChecked: {},
      checkedInterests: null,
      interesSelected: { title: 'Выберите', field: '' },
      genderSelected: { label: 'Выберите', field: '' },
      ageSelected: { label: 'Выберите', field: '' },
      regionSelected: { label: 'Выберите', field: '' },
      interestsList: [
        { title: 'Компьютерные игры и киберспорт', field: 'computer_games', count: 0 },
        { title: 'Путешествия', field: 'travel', count: 0 },
        { title: 'Юмор', field: 'humor', count: 0 },
        { title: 'Спорт', field: 'sport', count: 0 },
        { title: 'Животные', field: 'animal', count: 0 },
        { title: 'Танцы', field: 'dance', count: 0 },
        { title: 'Рисование / рукоделие', field: 'draw', count: 0 },
        { title: 'Пение', field: 'sing', count: 0 },
        { title: 'Программирование', field: 'programming', count: 0 },
        { title: 'Наука', field: 'science', count: 0 },
        { title: 'Музыка', field: 'music', count: 0 },
        { title: 'Кулинария', field: 'cookery', count: 0 },
        { title: 'Настольные игры', field: 'board_games', count: 0 },
        { title: 'Робототехника', field: 'robotics', count: 0 },
        { title: 'Другое', field: 'other', count: 0 },
      ],
      regionShortList: [
        { label: 'Москва', field: 'Москва' },
        { label: 'Московская область', field: 'Московская область' },
        { label: 'Санкт-Петербург', field: 'Санкт-Петербург' },
        { label: 'Челябинская область', field: 'Челябинская область' },
        { label: 'Самарская область', field: 'Самарская область' },
      ],
      statistics: null,
      genderStatistics: [{ title: 'Мужской', field: 'male', count: 0 }, { title: 'Женский', field: 'female', count: 0 }],
      ageStatistics: [{ title: '14 лет', field: 14, count: 0 }, { title: '15 лет', field: 15, count: 0 },
        { title: '16 лет', field: 16, count: 0 }, { title: 'Другое', field: 'other', count: 0 }],
      regionStatistics: [],
      character: {},
      elements: [
        {
          title: 'Видео-слайдер', field: 'videoSlider', bgColor: '#fee9ec', function: 'videoSlider();', translation: 'видео слайдер', html: '<div>videoSlider</div>', type: 'main',
        },
        {
          title: 'Фото-слайдер', field: 'photoSlider', bgColor: '#ebfaed', function: 'photoSlider();', translation: 'фото слайдер', html: '<div style="height: 10rem;">photoSlider</div>', type: 'main',
        },
        {
          title: 'Лайк', field: 'like', bgColor: '#eaeffe', function: 'like();', translation: 'лайк', html: '<div>like</div>', type: 'navigation',
        },
        {
          title: 'Сообщения', field: 'message', bgColor: '#fef8ec', function: 'message();', translation: 'сообщения', html: '<div>message</div>', type: 'main',
        },
        {
          title: 'Лента', field: 'news', bgColor: '#fef8ec', function: 'news();', translation: 'новости', html: '<div>news</div>', type: 'main',
        },
        {
          title: 'Поиск', field: 'search', bgColor: '#f8f4fe', function: 'search();', translation: 'поиск', html: '<div>search</div>', type: 'navigation',
        },
        {
          title: 'Профиль', field: 'profile', bgColor: '#ebfaed', function: 'profile();', translation: 'профиль', html: '<div>profile</div>', type: 'navigation',
        },
        {
          title: 'Плеер', field: 'player', bgColor: '#fbf5ff', function: 'player();', translation: 'плеер', html: '<div>player</div>', type: 'navigation',
        },
        {
          title: 'Запись', field: 'record', bgColor: '#fff5f6', function: 'record();', translation: 'запись', html: '<div>record</div>', type: 'main',
        },
        {
          title: 'Поделиться', field: 'share', bgColor: '#f5f7ff', function: 'share();', translation: 'поделиться', html: '<div>share</div>', type: 'navigation',
        },
      ],
      selectedElements: { zoneTop: '', zoneCenter: '', zoneBottom: '' },
      selectedElementsInfo: { zoneTop: null, zoneCenter: null, zoneBottom: null },
      selectedFunctions: { zoneTop: '', zoneCenter: '', zoneBottom: '' },
      highlight: 'zoneTop',
      elementIsChecked: {},
      testResult: { zoneTop: null, zoneCenter: null, zoneBottom: null },
      wrongTest: false,
      wrongTestMessage: 'Failed to load: the server responded with a status of 404 ()',
      publication: {
        title: '', name: '', surname: '', section: { title: 'Выбирете категорию', field: '' }, description: '',
      },
      showPublication: true,
      currentPopupId: null,
      popupList: [
        {
          icon: 'popup_img_1.svg',
          title: 'Привет!',
          description: 'Нейросети распространили свое влияние на большинство сфер человеческой жизни, в том числе и на разработку приложений.\r\n\r\n Нейросети ещё не способны полностью заменить человека. Но они способны стать хорошим помощником в решении различных узкоспециализированных задач.',
        },
        {
          icon: 'popup_img_2.svg',
          title: 'Разработка приложений',
          description: 'Давайте познакомимся с процессом разработки и создадим своё мобильное приложение. Узнаем, из каких этапов состоит эта работа, какие специалисты занимаются этим, что они делают, как нейросети помогают им в их работе.',
        },
        {
          title: null,
          description: 'Давай подведем итоги урока. Посмотри видео о пройденном сегодня материале про нейросети и коммуникации. Зафиксируй главные мысли и выводы.',
        },
        {
          title: 'Поздравляем!',
          /* eslint-disable quotes */
          description: 'Ты прошёл полный цикл разработки приложений: анализ и исследование, дизайн, разработка, тестирование и публикация приложения в маркете. А также узнал, как нейросети могут облегчить разработку.\r\n\r\n Поделись получившимся результатом с друзьями.\r\n Хочешь создать своё приложение для популярной социальной сети, '
            + `<a href="https://vk.com/vkappsdev" target="_blank">проходи по ссылке.</a>`,
        },
      ],
      showNextButton: false,
    }
  },
  computed: {
    cityImage() {
      switch (this.regionSelected.label) {
        case 'Москва':
          return 'city_1.svg'
        case 'Московская область':
          return 'city_2.svg'
        case 'Санкт-Петербург':
          return 'city_3.svg'
        case 'Челябинская область':
          return 'city_4.svg'
        case 'Самарская область':
          return 'city_1.svg'
        default:
          return 'blur.jpg'
      }
    },
    interestsListMobile() {
      return this.interestsList.map(item => ({
        ...item,
        title: `${item.title} (${item.count}%)`,
      }))
    },
    suggestions() {
      return this.elements.map(el => ({
        function: el.function,
        translation: el.translation,
      }))
    },
  },
  watch: {
    genderSelected() {
      this.character.gender = this.genderSelected.field
      this.updateCharacterName()
      this.updateCharacterDescription()
      this.updateStatistics()
    },
    ageSelected() {
      this.character.age = this.ageSelected.field
      this.updateCharacterName()
      this.updateCharacterDescription()
      this.updateStatistics()
    },
    regionSelected() {
      this.character.region = this.regionSelected.field
      this.updateCharacterDescription()
      this.updateStatistics()
    },
    interesSelected() {
      this.character.interests = this.interesSelected.title
      this.updateCharacterDescription()
      this.updateStatistics()
    },
    selectedFunctions: {
      deep: true,
      handler(val) {
        Object.keys(val).forEach((key) => {
          this.checkCode(key, val[key])
        })
      },
    },
  },
  methods: {
    closeHelpBox() {
      this.showHelpBox = false
      if (!this.helpBoxTextNumber) {
        this.helpBoxTextNumber += 1
        setTimeout(() => {
          this.showHelpBox = true
        }, 600)
      }
    },
    closeWarning() {
      if (this.currentTask === 3) {
        this.currentTask -= 1
      }
    },
    async getStatistics(params) {
      this.statistics = await api.getData(params)
      this.setPercentStatistics()
    },
    setPercentStatistics() {
      let sum = Object.values(this.statistics.interestsCount).reduce((a, b) => a + b)
      this.interestsList.forEach((item) => {
        item.count = Math.round(this.statistics.interestsCount[item.field] / sum * 100)
      })
      sum = Object.values(this.statistics.sexCount).reduce((a, b) => a + b)
      this.genderStatistics.forEach((item) => {
        item.count = Math.round(this.statistics.sexCount[item.field] / sum * 100)
        if (!item.count) item.count = 0
      })
      this.ageStatistics.forEach((item) => {
        if (item.field === 'other') {
          sum = 0
          Object.keys(this.statistics.ageCount)
            .filter(key => key > 16 && key < 97)
            .reduce((obj, key) => {
              obj[key] = this.statistics.ageCount[key]
              sum += obj[key]
              return obj
            }, {})
          item.count = sum
        } else {
          item.count = this.statistics.ageCount[item.field]
        }
        if (!item.count) item.count = 0
      })
      sum = this.ageStatistics.reduce((a, b) => a + b.count, 0)
      this.ageStatistics.forEach((age) => {
        age.count = Math.round(age.count / sum * 100)
      })
      this.regionStatistics.length = 0
      Object.keys(this.statistics.regionCount).forEach((key) => {
        this.regionStatistics.push({ title: key, count: this.statistics.regionCount[key] })
      })
      this.regionStatistics.sort((a, b) => b.count - a.count)
      if (this.regionStatistics.length > 4) this.regionStatistics.length = 5
      sum = this.regionStatistics.reduce((a, b) => a + b.count, 0)
      this.regionStatistics.forEach((item) => {
        item.count = Math.round(item.count / sum * 100)
      })
    },
    getChartData(statistics, colorThemeNumber) {
      const labelsArray = []
      const dataArray = []
      statistics.forEach((item) => {
        labelsArray.push(item.title)
        dataArray.push(item.count)
      })
      const colorTheme = [[
        '#84A6FF',
        '#892435',
        '#491C24',
        '#B896F5',
        '#1F070B',
        '#F8CD46',
      ], [
        '#F8CD46',
        '#FB3131',
        '#892435',
        '#1F3249',
      ]]
      return {
        labels: labelsArray,
        datasets: [
          {
            backgroundColor: colorTheme[colorThemeNumber],
            data: dataArray,
          },
        ],
      }
    },
    updateCharacterName() {
      if (!(this.character.gender !== null && this.character.age)) return
      switch (this.character.age) {
        case 14: {
          this.character.name = this.character.gender ? 'Скобец' : 'Запятыня'
          this.character.img = this.character.gender ? 1 : 5
          break
        }
        case 15: {
          this.character.name = this.character.gender ? 'Братец Слеш' : 'Запятыня'
          this.character.img = this.character.gender ? 2 : 5
          break
        }
        case 16: {
          this.character.name = this.character.gender ? 'Братец Слеш' : 'Маруся'
          this.character.img = this.character.gender ? 3 : 4
          break
        }
        default: {
          this.character.name = this.character.gender ? 'Братец Слеш' : 'Маруся'
          this.character.img = this.character.gender ? 3 : 4
        }
      }
    },
    updateCharacterDescription() {
      if (!this.character.name) return
      let str = this.character.name
      if (this.character.age !== 'other') str += `, ${this.character.age} лет`
      if (this.character.interests) str += `. Интересы: ${this.character.interests}`
      if (this.character.region) str += `. Локация: ${this.character.region}`
      this.character.description = str
      this.showNextButton = this.character.img && this.character.region && this.character.interests
    },
    updateInterestsSelected(value) {
      this.checkedInterests = value
      Object.keys(this.interestsIsChecked).forEach(key => key === value || delete this.interestsIsChecked[key])
      if (this.interestsIsChecked[value] === false) {
        this.checkedInterests = null
        this.character.interests = null
      } else {
        this.character.interests = Object.keys(this.interestsList).reduce((r, e) => {
          if (this.interestsList[e].field === this.checkedInterests) r = this.interestsList[e].title
          return r
        }, {})
      }
      this.updateCharacterDescription()
      this.updateStatistics()
    },
    updateStatistics() {
      const params = { sex_eq: this.genderSelected.field, in_interests: this.checkedInterests || this.interesSelected.field, region_eq: this.regionSelected.field }
      if (this.ageSelected.field === 'other') params.age_gt = 16
      else params.age_eq = this.ageSelected.field
      this.getStatistics(params)
    },
    updateTime() {
      const d = new Date()
      const h = (d.getHours() < 10 ? '0' : '') + d.getHours()
      const m = (d.getMinutes() < 10 ? '0' : '') + d.getMinutes()
      this.time = `${h}:${m}`
    },
    insertFunctionToCodeEditor(insertText) {
      this.selectedFunctions[this.highlight] = insertText
    },
    checkCode(zone, sentence) {
      this.$refs[`function_${zone}`].classList.remove('rightCode')
      if (sentence.length === 0 && this.testResult[zone] === false) this.testResult[zone] = null
      if (sentence.includes('//')) return
      if (sentence.substr(sentence.length - 3, sentence.length) === '();') {
        this.$refs[`function_${zone}`].classList.add('rightCode')
      }
      this.showNextButton = this.$refs.function_zoneTop.classList.contains('rightCode') && this.$refs.function_zoneCenter.classList.contains('rightCode') && this.$refs.function_zoneBottom.classList.contains('rightCode')
    },
    selectedFunctionsCheck(functionName) {
      return this.selectedFunctions.zoneTop.includes(functionName) || this.selectedFunctions.zoneCenter.includes(functionName) || this.selectedFunctions.zoneBottom.includes(functionName)
    },
    setFocus(zone) {
      if (this.currentTask === 2) {
        this.highlight = zone
      }
      if (this.currentTask === 3) {
        this.testElement(this.selectedElements[zone])
        this.elementIsChecked[this.selectedElements[zone]] = true
      }
    },
    setElementsContant() {
      this.selectedElementsInfo.zoneTop = this.elements.find(x => x.field === this.selectedElements.zoneTop)
      this.selectedElementsInfo.zoneCenter = this.elements.find(x => x.field === this.selectedElements.zoneCenter)
      this.selectedElementsInfo.zoneBottom = this.elements.find(x => x.field === this.selectedElements.zoneBottom)
    },
    testElement(el) {
      const zone = Object.keys(this.selectedElements).find(key => this.selectedElements[key] === el)
      this.testResult[zone] = this.selectedElementsInfo[zone].function === this.selectedFunctions[zone]
      if (!this.testResult[zone]) {
        this.$refs[`check${el}`][0].classList.add('wrongTest')
        this.wrongTestMessage += `<br><span style="color: #FF003D;"> // Функция ${this.selectedFunctions[zone]} не работает</span>`
        this.wrongTest = true
        this.showHelpBox = true
      }
      this.showNextButton = this.testResult.zoneTop && this.testResult.zoneCenter && this.testResult.zoneBottom
    },
    closePublicationPopup(publication) {
      this.publication = publication
      this.showPublication = false
      this.score += 20
      setTimeout(() => {
        this.currentPopupId = 2
        this.stopTimer()
      }, 500)
    },
    handleDropped(ev) {
      // нельзя переносить в конструктор
      if (ev.data.overContainer.attributes.getNamedItem('data-type').value === 'constructor') {
        ev.cancel()
        return
      }
      const optionType = ev.data.dragEvent.data.source.attributes.getNamedItem('data-type').value
      const isNav = ev.data.dragEvent.data.source.attributes.getNamedItem('data-zone').value === 'navigation'
      const currentZone = ev.data.over.parentElement.attributes.getNamedItem('data-container').value
      // проверка зоны и типа элемента
      if ((isNav && currentZone === 'zoneCenter') || (!isNav && currentZone !== 'zoneCenter')) {
        ev.cancel()
        return
      }
      // если элемент был на экране в другой зоне, то очистить ее
      // добавить зону, с которой поменяли, т.к. она мб не пустая
      const wasOnCurrentZone = this.selectedElements[currentZone]
      const lastZone = Object.keys(this.selectedElements).find(key => this.selectedElements[key] === optionType)
      if (lastZone) {
        this.selectedElements[lastZone] = wasOnCurrentZone || ''
      }
      // добавить элемент в список выбранных
      if (currentZone) {
        this.$refs[currentZone].classList.add('draggable-dropzone--occupied')
        this.selectedElements[currentZone] = optionType
      }
      this.showNextButton = this.selectedElements.zoneTop && this.selectedElements.zoneCenter && this.selectedElements.zoneBottom
    },
    highlightDropped(ev) {
      const isNav = ev.data.source.attributes.getNamedItem('data-zone').value === 'navigation'
      this.$refs.zoneTop.children[0].classList.add(isNav ? 'highlightGreen' : 'highlightRed')
      this.$refs.zoneCenter.children[0].classList.add(isNav ? 'highlightRed' : 'highlightGreen')
      this.$refs.zoneBottom.children[0].classList.add(isNav ? 'highlightGreen' : 'highlightRed')
    },
    unhighlightDropped() {
      document.querySelectorAll('.highlightGreen').forEach(el => el.classList.remove('highlightGreen'))
      document.querySelectorAll('.highlightRed').forEach(el => el.classList.remove('highlightRed'))
    },
    initDroppable() {
      this.result = new Set()
      this.droppable = new Swappable(document.querySelectorAll('.block'), {
        draggable: '.item',
        dropzone: '.dropzone',
      })
      this.droppable.on('drag:start', this.highlightDropped)
      this.droppable.on('drag:stop', this.unhighlightDropped)
      this.droppable.on('swappable:swap', this.handleDropped)
    },
    init() {
      setTimeout(() => {
        this.currentPopupId = 0
      }, 300)
      this.getStatistics()
      this.updateTime()
    },
    initTask() {
      this.currentTask += 1
      if (this.wrongTest) this.wrongTest = false
      else {
        this.score += 20
        this.helpBoxTextNumber = 0
        this.showHelpBox = true
      }
      this.showNextButton = false
      this.updateTime()
    },
    showNextTask() {
      switch (this.currentTask) {
        case 0:
          this.initTask()
          this.initDroppable()
          break
        case 1: {
          this.setElementsContant()
          this.initTask()
          this.$nextTick(() => {
            this.$refs.zoneTopFunction.$el.focus()
          })
          break
        }
        case 2:
          this.initTask()
          this.setElementsContant()
          this.elementIsChecked = {}
          this.wrongTestMessage = 'Failed to load: the server responded with a status of 404 ()'
          this.testResult = { zoneTop: null, zoneCenter: null, zoneBottom: null }
          break
        case 3:
          this.initTask()
          break
        case 4:
          break
        default: break
      }
      this.$nextTick(() => {
        this.$refs.lesson.scrollTop = 0
      })
    },
    closePopupHandler(id) {
      switch (id) {
        case 0:
          setTimeout(() => {
            this.currentPopupId = 1
          }, 500)
          break
        case 1:
          this.showHelpBox = true
          break
        case 2:
          this.currentPopupId = 3
          break
        case 3:
          this.$router.push({ name: 'test', query: this.$route.query })
          break
        default:
      }
    },
    getCertificate() {
      this.saveData({})
    },
  },
  mounted() {
    this.init()
    this.startTimer()
  },
}
</script>
<style lang="scss" module>
  @import './lesson4.scss';
</style>
